import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

const PolymorphicWithOverrides = /*#__PURE__*/forwardRef(function PolymorphicWithOverrides({
  __overrides,
  ...restProps
}, ref) {
  const {
    as: Element,
    ...restOverrides
  } = __overrides;
  return /*#__PURE__*/jsx(Element, {
    ref: ref,
    ...restProps,
    ...restOverrides
  });
});

export { PolymorphicWithOverrides };
//# sourceMappingURL=PolymorphicWithOverrides.mjs.map
